import { actionTypeDoctor } from "../types";

const initialState = {
    loading: false,
    error: null,
    getLanguagesData: [],
    getDashboardByDoctorIdData: [],
    getProfileInfoData: [],
    getAdditionalInfoData: [],
    getClinicDoctorDetailsData: [],
    getFeesData: [],
    getAllAdditionalServicesData: [],
    getDefaultTimingData: [],
    getCustomTimingData: [],
    getClinicDetailsByDoctorIdData: [],
    getClinicDoctorServiceAndScheduleData: [],
    getAllClinicRequestsData: [],
    getAllDoctorClinicRequestsData: [],
    postDoctorsPatientData: [],
    postFinanceData: [],
    getClinicDoctorData: [],
    getChatAppointmentByDoctorData: [],
    getEmergencyCallByDoctorData: [],
    getFaqData: [],
    getAllInvoiceDoctorByIdData: [],
    getDiagnosticByIdData: [],
    getAllAppointmentDetailData: [],
    getAdditionalServiceInfoData: [],
    getAllAppointmentDetailListData: [],
    getInvoiceSettingByGuidData: [],
    getInvoiceData: [],
    postSaveInvoiceListData: [],
    getMassMessagesData: [],
    postBookedEmergencyAppointmentData: [],
    postGetChatHistoryData: [],
    getListPatientDetailsByDoctorData: [],
    getChatNotificationData: [],
    postAllClinicData: [],
    postSearchClinicAppointmentData: []
};

const reducerDoctor = (state = initialState, action) => {
    switch (action.type) {
        case actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_SUCCESS:
            return {
                ...state,
                getDashboardByDoctorIdData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_PROFILE_INFO_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_PROFILE_INFO_SUCCESS:
            return {
                ...state,
                getProfileInfoData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_PROFILE_INFO_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ADDITIONAL_INFO_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ADDITIONAL_INFO_SUCCESS:
            return {
                ...state,
                getAdditionalInfoData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_ADDITIONAL_INFO_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_SUCCESS:
            return {
                ...state,
                getClinicDoctorDetailsData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_FEES_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_FEES_SUCCESS:
            return {
                ...state,
                getFeesData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_FEES_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_SUCCESS:
            return {
                ...state,
                getAllAdditionalServicesData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_DEFAULT_TIMING_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_DEFAULT_TIMING_SUCCESS:
            return {
                ...state,
                getDefaultTimingData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_DEFAULT_TIMING_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CUSTOM_TIMING_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CUSTOM_TIMING_SUCCESS:
            return {
                ...state,
                getCustomTimingData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_CUSTOM_TIMING_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DETAILS_BY_DOCTOR_ID_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DETAILS_BY_DOCTOR_ID_SUCCESS:
            return {
                ...state,
                getClinicDetailsByDoctorIdData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DETAILS_BY_DOCTOR_ID_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_SUCCESS:
            return {
                ...state,
                getClinicDoctorServiceAndScheduleData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.CLEAR_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_DATA:
            return {
                ...state,
                getClinicDoctorServiceAndScheduleData: [],
            };

        case actionTypeDoctor.GET_ALL_CLINIC_REQUESTS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_CLINIC_REQUESTS_SUCCESS:
            return {
                ...state,
                getAllClinicRequestsData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_CLINIC_REQUESTS_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_DOCTOR_CLINIC_REQUESTS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_DOCTOR_CLINIC_REQUESTS_SUCCESS:
            return {
                ...state,
                getAllDoctorClinicRequestsData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_DOCTOR_CLINIC_REQUESTS_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_DOCTORS_PATIENT_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_DOCTORS_PATIENT_SUCCESS:
            return {
                ...state,
                postDoctorsPatientData: action.payload,
                error: null,
            };
        case actionTypeDoctor.POST_DOCTORS_PATIENT_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_FINANCE_DATA_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_FINANCE_DATA_SUCCESS:
            return {
                ...state,
                postFinanceData: action.payload,
                error: null,
            };
        case actionTypeDoctor.POST_FINANCE_DATA_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DOCTOR_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DOCTOR_SUCCESS:
            return {
                ...state,
                getClinicDoctorData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_CLINIC_DOCTOR_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CHAT_APPOINTMENT_BY_DOCTOR_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CHAT_APPOINTMENT_BY_DOCTOR_SUCCESS:
            return {
                ...state,
                getChatAppointmentByDoctorData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_CHAT_APPOINTMENT_BY_DOCTOR_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_EMERGENCY_CALL_BY_DOCTOR_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_EMERGENCY_CALL_BY_DOCTOR_SUCCESS:
            return {
                ...state,
                getEmergencyCallByDoctorData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_EMERGENCY_CALL_BY_DOCTOR_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_FAQ_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_FAQ_SUCCESS:
            return {
                ...state,
                getFaqData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_FAQ_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypeDoctor.GET_ALL_INVOICE_DOCTOR_BY_ID_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_INVOICE_DOCTOR_BY_ID_SUCCESS:
            return {
                ...state,
                getAllInvoiceDoctorByIdData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_INVOICE_DOCTOR_BY_ID_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_DIAGNOSTIC_BY_ID_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_DIAGNOSTIC_BY_ID_SUCCESS:
            return {
                ...state,
                getDiagnosticByIdData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_DIAGNOSTIC_BY_ID_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_SUCCESS:
            return {
                ...state,
                getAllAppointmentDetailData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ADDITIONAL_SERVICE_INFO_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ADDITIONAL_SERVICE_INFO_SUCCESS:
            return {
                ...state,
                getAdditionalServiceInfoData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_ADDITIONAL_SERVICE_INFO_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_LIST_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_LIST_SUCCESS:
            return {
                ...state,
                getAllAppointmentDetailListData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_LIST_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_INVOICE_SETTING_BY_GUID_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_INVOICE_SETTING_BY_GUID_SUCCESS:
            return {
                ...state,
                getInvoiceSettingByGuidData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_INVOICE_SETTING_BY_GUID_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypeDoctor.GET_INVOICE_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_INVOICE_SUCCESS:
            return {
                ...state,
                getInvoiceData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_INVOICE_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypeDoctor.POST_SAVE_INVOICE_LIST_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_SAVE_INVOICE_LIST_SUCCESS:
            return {
                ...state,
                postSaveInvoiceListData: action.payload,
                error: null,
            };
        case actionTypeDoctor.POST_SAVE_INVOICE_LIST_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_MASS_MESSAGES_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_MASS_MESSAGES_SUCCESS:
            return {
                ...state,
                getMassMessagesData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_MASS_MESSAGES_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_BOOKED_EMERGENCY_APPOINTMENT_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_BOOKED_EMERGENCY_APPOINTMENT_SUCCESS:
            return {
                ...state,
                postBookedEmergencyAppointmentData: action.payload,
                error: null,
            };
        case actionTypeDoctor.POST_BOOKED_EMERGENCY_APPOINTMENT_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypeDoctor.POST_GET_CHAT_HISTORY_REQUESTT:
            return {
                ...state,
                error: null,
                loading: false
            };
        case actionTypeDoctor.POST_GET_CHAT_HISTORY_SUCCESSS:
            return {
                ...state,
                postGetChatHistoryData: action.payload,
                error: null,
                loading: false
            };
        case actionTypeDoctor.POST_GET_CHAT_HISTORY_FAILUREE:
            return {
                ...state,
                error: null,
                loading: false
            };

        case actionTypeDoctor.GET_LIST_PATIENT_DETAILS_BY_DOCTOR_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_LIST_PATIENT_DETAILS_BY_DOCTOR_SUCCESS:
            return {
                ...state,
                getListPatientDetailsByDoctorData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_LIST_PATIENT_DETAILS_BY_DOCTOR_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CHAT_NOTIFICATION_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.GET_CHAT_NOTIFICATION_SUCCESS:
            return {
                ...state,
                getChatNotificationData: action.payload,
                error: null,
            };
        case actionTypeDoctor.GET_CHAT_NOTIFICATION_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_ALL_CLINIC_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_ALL_CLINIC_SUCCESS:
            return {
                ...state,
                postAllClinicData: action.payload,
                error: null,
            };
        case actionTypeDoctor.POST_ALL_CLINIC_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_SEARCH_CLINIC_APPOINTMENT_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeDoctor.POST_SEARCH_CLINIC_APPOINTMENT_SUCCESS:
            return {
                ...state,
                postSearchClinicAppointmentData: action.payload,
                error: null,
            };
        case actionTypeDoctor.POST_SEARCH_CLINIC_APPOINTMENT_FAILURE:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};

export default reducerDoctor;
